function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".muteClass2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.08px;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 168",
  d: "M326.23,198.94v-4.58l-2.29,2.29",
  transform: "translate(-321.65 -193.25)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 169",
  d: "M326.23,201.69v1.83l-2.29-2.29h-2.29v-4.58h.74Z",
  transform: "translate(-321.65 -193.25)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_170",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 170",
  className: "muteClass2",
  d: "M327.66,195.8",
  transform: "translate(-321.65 -193.25)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_170-2",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 170",
  className: "muteClass2",
  d: "M328.52,198.94",
  transform: "translate(-321.65 -193.25)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_171",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 171",
  className: "muteClass2",
  d: "M329.32,194.14",
  transform: "translate(-321.65 -193.25)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_171-2",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 171",
  className: "muteClass2",
  d: "M330.81,198.94",
  transform: "translate(-321.65 -193.25)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 172",
  className: "muteClass2",
  d: "M328.29,201",
  transform: "translate(-321.65 -193.25)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_172-2",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 172",
  className: "muteClass2",
  d: "M328.52,199.29",
  transform: "translate(-321.65 -193.25)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M329.89,203.18",
  transform: "translate(-321.65 -193.25)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173-2",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M330.29,202.27",
  transform: "translate(-321.65 -193.25)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173-3",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M329.32,194.14",
  transform: "translate(-321.65 -193.25)"
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  id: "Line_133",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Line 133",
  className: "muteClass2",
  x1: 0.57,
  y1: 0.54,
  x2: 8.59,
  y2: 10.85
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173-4",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M329.32,194.14c2.37,3.3.82,8.09.47,9",
  transform: "translate(-321.65 -193.25)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173-5",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M328.15,201.1",
  transform: "translate(-321.65 -193.25)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173-6",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M327.65,195.8",
  transform: "translate(-321.65 -193.25)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_173-7",
  fill: "currentColor",
  stroke: "currentColor",
  "data-name": "Path 173",
  className: "muteClass2",
  d: "M327.65,195.8a6.26,6.26,0,0,1,.5,5.3",
  transform: "translate(-321.65 -193.25)"
});

function SvgIconMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.5 11.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMute);
export default __webpack_public_path__ + "static/media/icon-mute.88f1f41c.svg";
export { ForwardRef as ReactComponent };